import React from "react";
import PropTypes from 'prop-types'
import '../../../styles/index.sass'

function CheckboxInput(props) {
    return (
        <div onClick={props.onClick}
             className={'list__option'} key={props.keys}>
            <input
                ref={props.reff}
                name={props.name}
                value={props.value}
                type="checkbox"
                id={props.value}
                checked={props.checked}
                key={props.keys}
                className={props.className}
            />
            <label htmlFor={props.value}>{props.title}</label>
        </div>
    )
}

CheckboxInput.propTypes = {
    title: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    checked: PropTypes.bool,
    key: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    onChange: PropTypes.func
}
// CheckboxInput.defaultProps = {
//     title: 'Checkbox Input'
// }

export default CheckboxInput